module.exports = __webpack_public_path__ + "static/media/main_large.79793753.jpg";